import React, { useState } from "react";
import { API } from "./../../config/api";

export default function ChangePassword() {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // ✅ ADD SHOW/HIDE STATES
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.newPassword !== form.confirmPassword) {
      alert("New Password and Confirm Password must match");
      return;
    }

    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      alert("User session not found. Please login again");
      return;
    }

    try {
      const res = await fetch(API.CHANGE_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: user.id,
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("Password Updated Successfully");
        window.history.back();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      alert("Server Error");
    }
  };

  return (
    <div className="password-overlay" onClick={() => window.history.back()}>
      <div className="password-popup" onClick={(e) => e.stopPropagation()}>
        <button
          className="password-close"
          onClick={() => window.history.back()}
        >
          ✖
        </button>

        <div className="password-header">
          <h3>Change Password</h3>
        </div>

        <form onSubmit={handleSubmit}>
          {/* CURRENT PASSWORD */}
          <div className="password-field">
            <label>Current Password</label>

            <div className="password-wrapper">
              <input
                type={showCurrent ? "text" : "password"}
                name="currentPassword"
                value={form.currentPassword}
                onChange={handleChange}
                placeholder="Enter current password"
                required
              />

              <span
                className="password-toggle"
                onClick={() => setShowCurrent(!showCurrent)}
              >
                <i
                  className={`bi ${showCurrent ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </span>
            </div>
          </div>

          {/* NEW PASSWORD */}
          <div className="password-field">
            <label>New Password</label>

            <div className="password-wrapper">
              <input
                type={showNew ? "text" : "password"}
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                placeholder="Enter new password"
                required
              />

              <span
                className="password-toggle"
                onClick={() => setShowNew(!showNew)}
              >
                <i className={`bi ${showNew ? "bi-eye-slash" : "bi-eye"}`}></i>
              </span>
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="password-field">
            <label>Confirm Password</label>

            <div className="password-wrapper">
              <input
                type={showConfirm ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm new password"
                required
              />

              <span
                className="password-toggle"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                <i
                  className={`bi ${showConfirm ? "bi-eye-slash" : "bi-eye"}`}
                ></i>
              </span>
            </div>
          </div>

          <button className="password-submit" type="submit">
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
}
